module.exports = __webpack_public_path__ + "static/img/img31.5c3edcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img31.png
// module id = xQt4
// module chunks = 1